import React from 'react';

import {LinkBase} from '../link/link-base/link-base';
import styles from './breadcrumbs.module.scss';

interface BreadcrumbsProps {
    breadcrumbs: {
        name?: string;
        href: string;
    }[];
}

const Breadcrumbs = (props: BreadcrumbsProps) => {
    return (
        <div className={styles['breadcrumbs-wrapper']}>
            {
                props.breadcrumbs.map((breadcrumb, index, array) =>
                    <div key={`breadcrumb-${index}`} className={styles['breadcrumbs']}>
                        {index !== 0
                            ? <div className={styles['separator']}>/</div>
                            : undefined
                        }
                        <LinkBase
                            href={breadcrumb.href}
                            className={`${styles['link']} ${index === array.length - 1 ? styles['last-link'] : ''}`}>
                            {breadcrumb.name
                                ? breadcrumb.name.length > 30
                                    ? `${breadcrumb.name.substring(0, 30)}...`
                                    : breadcrumb.name
                                : ''
                            }
                        </LinkBase>
                    </div>
                )
            }
        </div>
    );
};

export default Breadcrumbs;
